import { API } from "@Config/index";
import axios from "axios";

export function getClassDetailAdmin(id, type, page = 1, limit = 5) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/admins/class/${id}?type=${type}&limit=${limit}&page=${page}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data.data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getClassesAdmin(type, page = 1, limit = 5, isFinished, search) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/admins/class?type=${type}&limit=${limit}&page=${page}&isFinished=${isFinished}&search=${search}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data.data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getClassAbsence(id, sessionNum = 1, courseBatch = 1) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/admins/class/attendance/${id}?courseBatch=${courseBatch}&sessionNum=${sessionNum}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data.data);
    } catch (error) {
      reject(error);
    }
  });
}

export function updateAttendance(id, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.patch(
        `/admins/class/attendance/${id}`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDataTablePrakerja(page, limit) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/admins/userSheets?limit=${limit}&page=${page}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function downloadDataRedeem() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/admins/dataReedem`, {
        headers: {
          Authorization: localStorage.getItem("accessToken"),
        },
        responseType: "arraybuffer",
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function updateDataRedeem(file) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.patchForm(
        `/admins/dataReedem`,
        { file },
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function updateDataReport(file) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.patchForm(
        `/admins/dataReport`,
        { file },
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
export function updateDataNotifRegister(file) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.postForm(
        `/admins/notifications`,
        { file },
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
export function getDataNotifValidation(page, limit,search) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/admins/students/validate?limit=${limit}&page=${page}&search=${search}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDataNotifLearn(page, limit,search) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/admins/classes?limit=${limit}&page=${page}&search=${search}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDataNotifPromo(page, limit,search) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/admins/students/names?limit=${limit}&page=${page}&search=${search}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function downloadDataCompletion() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/admins/dataCompletion`, {
        headers: {
          Authorization: localStorage.getItem("accessToken"),
        },
        responseType: "arraybuffer",
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getListTemplate() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axios.get(
        "https://service-chat.qontak.com/api/open/v1/templates/whatsapp",
        {
          headers: {
            Authorization: "Bearer 3S08XbBeqPe-MuEHBUBgUkZLFNGVTKgY0Sin5XYu1QI",
          },
          responseType: "arraybuffer",
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessageRegister(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/register`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessageRedeem(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/redeem`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessageValidation(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/nameValidation`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessageValidationAll(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/nameValidation/all`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessagePromo(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/promo`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessagePromoAll(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/promo/all`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessageLearn(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/classReminder`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendMessageLearnAll(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/admins/notifications/classReminder/all`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
